import { useState } from 'react';
import { useGetOne } from 'react-admin';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { getChainId } from '../../lib';

const STORAGE_KEY = 'pontuax_gift_migration_notice_dismissed';

const isDismissed = (): boolean => {
	try {
		return localStorage.getItem(STORAGE_KEY) === 'true';
	} catch {
		return false;
	}
};

const GiftMigrationNotice = () => {
	const [open, setOpen] = useState(!isDismissed());
	const chainId = getChainId();
	const { data: chain } = useGetOne('chains', { id: chainId }, { enabled: !!chainId });

	const handleClose = () => {
		setOpen(false);
		localStorage.setItem(STORAGE_KEY, 'true');
	};

	if (!chain?.useGift || !open) return null;

	return (
		<Dialog open onClose={handleClose} maxWidth="sm" fullWidth>
			<DialogTitle sx={{ fontWeight: 'bold' }}>
				Novidade: Clube de Vantagens
			</DialogTitle>
			<DialogContent>
				<Typography sx={{ mb: 2 }}>
					Os brindes agora fazem parte do <strong>Clube de Vantagens</strong>!
				</Typography>
				<Typography sx={{ mb: 2 }}>
					{"O cadastro e gerenciamento de brindes n\u00e3o \u00e9 mais feito na edi\u00e7\u00e3o de produto. Acesse o menu "}
					<strong>Clube de Vantagens</strong>
					{" para criar e gerenciar seus brindes."}
				</Typography>
				<Typography>
					<Link to="/gifts">Ir para o Clube de Vantagens</Link>
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} variant="contained">
					Entendi
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default GiftMigrationNotice;
